import axios from "axios";
import { Env } from "./common/constants";


const getInstance = () => {
    let baseURL;
    let apiKey;
    switch (process.env.REACT_APP_ENV) {
        case Env.Dev:
        case Env.Staging:
            baseURL = 'https://ent-sls-sms-api-non-prod.msd0004.stateauto.com/';
            apiKey = `xRrbNNaous9uD0hAPUfSz4LeHT8UWYiR1sNlpFpz`;
            break;
        case Env.Prod:
            baseURL = 'https://ent-sls-sms-api-prod.msp0004.stateauto.com/';
            apiKey = `OOlRy1kKfX4C6TEjuNfFS9p2ClbuVt4CeTJGHDLe`;
            break;
    }
    let axiosInstance = axios.create({
        baseURL: baseURL,
        timeout: 60000,
        headers: {
            'x-api-key': apiKey
        },
    });

    return axiosInstance;
}

export default getInstance();